import "common/polyfills";

import App from "./App";
import render from "../common/utils/render";

render(App);
